import { isPre, isRelease } from './index'
// @ts-ignore
export const TokenName = process.env.NODE_ENV !== 'production' ? 'local-pay-token' : import.meta.env.VITE_RUN_ENV === 'test' ? 'kopglobal-test-token' : 'kopglobal-pay-token'
export const CookieDomain = import.meta.env.VITE_TOKEN_DOMAIN
// @ts-ignore
export const LangName = process.env.NODE_ENV !== 'production' ? 'local-pay-lang' : 'kopglobal-pay-lang'
export const isHttps = (isPre || isRelease) // 域名是否为https，设置cookie时有用
export const SandboxModeKey = 'is-sandbox'
export const SiteBuilderLocalPort = 3002